import type {InlineRelationsData, InlineRelationsResponse} from "../types";
import {buildTopicUrl} from "../contentUtils";
import {TOPIC_TYPE_PATHS} from "../paths";
import {ExperimentalLink} from "../../../components/ExperimentalLink";
import articleClasses from "../HtmlArticle.module.css";
import panelClasses from "./panelContent.module.css";

type RelationGroup = {
    topictypeId: string;
    heading: string;
    items: InlineRelationsData[];
};

const groupByTopictypeId = (items: InlineRelationsData[]): RelationGroup[] => {
    const map = new Map<string, InlineRelationsData[]>();

    for (const item of items) {
        const existing = map.get(item.topictypeId);
        if (existing) {
            existing.push(item);
        } else {
            map.set(item.topictypeId, [item]);
        }
    }

    return Array.from(map.entries()).map(([topictypeId, groupItems]) => ({
        topictypeId,
        heading: TOPIC_TYPE_PATHS[topictypeId] ?? topictypeId,
        items: groupItems,
    }));
};

export const PanelInlineRelations = ({
    data,
}: {
    data: InlineRelationsResponse;
}) => {
    const items = data.related
        .map((id) => data.objects[id]?.data)
        .filter(Boolean);

    const groups = groupByTopictypeId(items);

    return (
        <div className={articleClasses.content}>
            {groups.map((group) => (
                <div
                    className={panelClasses.relationGroup}
                    key={group.topictypeId}
                >
                    <div className={panelClasses.relationGroupHeading}>
                        {group.heading}
                    </div>
                    <ul className={panelClasses.relationList}>
                        {group.items.map((item) => (
                            <li key={item.id}>
                                <ExperimentalLink
                                    href={buildTopicUrl(
                                        item.topictypeId,
                                        item.name,
                                        item.topicId,
                                        item.dataSegmentId
                                    )}
                                >
                                    {item.name}
                                </ExperimentalLink>
                                {item.subname && (
                                    <>
                                        {" "}
                                        <span className={panelClasses.subname}>
                                            {item.subname}
                                        </span>
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
};
